module.exports = __webpack_public_path__ + "static/media/ic_run_rtv.b7a1fd18.svg";